module.exports = __webpack_public_path__ + "static/media/04_1440.74950aed.jpeg";